export const BASE_URL = 'https://mate.academy/students-api';
